import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {colors} from './palette';

// Kept close to homey-admin-app's plain Aura look (this is an internal tool -
// no redesign) - just wires Aura's primary color scale to the shared blue
// palette from palette.ts instead of introducing a new one.
export const AdminV2Theme = definePreset(Aura, {
  primitive: {
    ...colors,
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        // Aura's default is color/hover/active = primary.500/600/700. Shifted
        // one step darker because primary.500 (#376ef7) is only 4.46:1 against
        // the white contrastColor, below the WCAG AA 4.5:1 for button labels;
        // primary.600 (#2563eb) is 5.17:1. Shifting the whole triple rather
        // than just remapping primary.500 keeps hover and active visibly
        // distinct from the resting state.
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}',
        },
      },
    },
  },
});
